
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qualification/buyer",
      function () {
        return require("private-next-pages/qualification/buyer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qualification/buyer"])
      });
    }
  